"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_PRODUCTS = void 0;
var SELECT_PRODUCTS = {
  ROW__MARKET_PRICE_PRODUCT: 'newOrderFlow-tr-marketPriceProduct',
  ROW__PRICE_UNIT_PRODUCT: 'newOrderFlow-tr-priceUnitDifferentFromSalesUnitProduct',
  ROW__PRODUCT: 'newOrderFlow-tr-product',
  TEXT__SELECTED_PRODUCTS: 'newOrderFlow-span-selectedProducts',
  TEXT__BANNER: 'newOrderFlow-div-warningBanner',
  TEXT__ORDER_TOTAL: 'newOrderFlow-span-total',
  TEXT__PRODUCT_NAME: 'newOrderFlow-span-productName',
  TEXT__PRODUCT_SKU: 'newOrderFlow-span-productSKU',
  TEXT__PRODUCT_CATEGORY: 'newOrderFlow-span-category',
  TEXT__PRODUCT_STOCK: 'newOrderFlow-span-stock',
  TEXT__UNIT: 'newOrderFlow-span-unit',
  TEXT__AMOUNT: 'newOrderFlow-span-amount',
  INPUT__SEARCH: 'newOrderFlow-input-search',
  INPUT__PRICE: 'newOrderFlow-input-pricePerUnit',
  INPUT__QUANTITY: 'newOrderFlow-input-quantity',
  INPUT__AMOUNT: 'newOrderFlow-input-amount',
  BUTTON__SELECT_PRODUCT: 'newOrderFlow-button-selectProduct'
};
exports.SELECT_PRODUCTS = SELECT_PRODUCTS;